export const VALUE_COMPARISON_CHECKED_DATE = "2026-08-21";
export const VALUE_COMPARISON_CHECKED_LABEL = "21 August 2026";
export const ONS_VALUE_COMPARISON_PERIOD = "July 2026";

export interface PriceSourceSnapshot {
    sourceLabel: string;
    sourceUrl: string;
    checkedDate: string;
}

export interface StreamingPriceSnapshot extends PriceSourceSnapshot {
    id: string;
    provider: string;
    plan: string;
    currency: "GBP" | "USD";
    priceMinor: number;
    priceSuffix: string;
}

export interface EverydayPriceSnapshot {
    id: string;
    label: string;
    detail: string;
    priceMinor: number;
}

export const ICKONIC_PRICE_SOURCE: Readonly<PriceSourceSnapshot> = {
    sourceLabel: "Ickonic",
    sourceUrl: "https://ickonic.com/sign-up",
    checkedDate: VALUE_COMPARISON_CHECKED_DATE,
};

export const STREAMING_PRICE_SNAPSHOT: ReadonlyArray<StreamingPriceSnapshot> = [
    {
        id: "apple-tv",
        provider: "Apple TV",
        plan: "Monthly subscription",
        currency: "GBP",
        priceMinor: 999,
        priceSuffix: "/month",
        sourceLabel: "Apple",
        sourceUrl: "https://www.apple.com/uk/apple-tv/",
        checkedDate: VALUE_COMPARISON_CHECKED_DATE,
    },
    {
        id: "disney-plus-standard",
        provider: "Disney+",
        plan: "Standard without ads",
        currency: "GBP",
        priceMinor: 999,
        priceSuffix: "/month",
        sourceLabel: "Disney+",
        sourceUrl:
            "https://help.disneyplus.com/en-GB/article/disneyplus-en-gd-price",
        checkedDate: VALUE_COMPARISON_CHECKED_DATE,
    },
    {
        id: "netflix-standard",
        provider: "Netflix",
        plan: "Standard without adverts",
        currency: "GBP",
        priceMinor: 1299,
        priceSuffix: "/month",
        sourceLabel: "Netflix",
        sourceUrl: "https://www.netflix.com/gb/title/80018294?source=35",
        checkedDate: VALUE_COMPARISON_CHECKED_DATE,
    },
    {
        id: "gaia-monthly",
        provider: "Gaia",
        plan: "Monthly membership",
        currency: "USD",
        priceMinor: 1599,
        priceSuffix: "/month + applicable tax",
        sourceLabel: "Gaia",
        sourceUrl: "https://www.gaia.com/invite/join",
        checkedDate: VALUE_COMPARISON_CHECKED_DATE,
    },
];

export const EVERYDAY_PRICE_SNAPSHOT: ReadonlyArray<EverydayPriceSnapshot> = [
    {
        id: "sandwich-and-coffee",
        label: "A sandwich and a coffee",
        detail: "Takeaway sandwich plus restaurant coffee",
        priceMinor: 828,
    },
    {
        id: "two-draught-lagers",
        label: "Two draught lagers",
        detail: "Two standard-strength pints",
        priceMinor: 946,
    },
    {
        id: "fish-and-chips",
        label: "Fish and chips",
        detail: "One takeaway meal",
        priceMinor: 1143,
    },
];

export const ONS_VALUE_COMPARISON_SOURCE: Readonly<PriceSourceSnapshot> = {
    sourceLabel: "ONS Shopping Prices Comparison Tool",
    sourceUrl:
        "https://www.ons.gov.uk/economy/inflationandpriceindices/articles/shoppingpricescomparisontool/2023-05-03",
    checkedDate: VALUE_COMPARISON_CHECKED_DATE,
};
